<template>
  <div>
    <div class="content">
        <div class="breadcrum warp">
            <ul>
               <li>
                 <a href="/">首页</a>
                 <span>></span>
               </li>
               <li v-for="(item,index) in breadCrumList" :key="index">
                  <a :href="item.url?item.url:'javascript:;'">{{item.name}}</a>
                  <span v-if="index<breadCrumList.length-1">></span>
               </li>
            </ul>    
        </div>
    </div>
  </div>  
</template>
<script>
export default {
    props:['breadCrumList']
}
</script>
<style  lang="less" scoped>
.content{
  margin-top: 10px;
  border-bottom: 1px solid #DCDCDC;
  margin-bottom: 30px;
  width: 100%;
}
.breadcrum{
  display: flex;
  align-items: center;
  margin: 0 auto;
  height: 30px;
  line-height:30px;
  padding-bottom: 10px;
  /* width: 78%; */
  /* margin-left: 10%; */
  ul{
   display: flex;
   li:last-child{
     a{
       color: #343434;
     }
   }
  }
}
.breadcrum span{
  padding: 0px 5px;
  color: #9A9A9A;
}
.breadcrum a {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A9A9A;
}
.breadcrum a.host{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
</style>


// WEBPACK FOOTER //
// src/common/breadCrum.vue